import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

class Page extends React.Component {
  static propTypes = {
    header: React.PropTypes.string,
    subheader: React.PropTypes.string,
    text: React.PropTypes.string
  };

  static defaultProps = {
    header: '',
    subheader: '',
    text: ''
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let { header, subheader, text } = this.props;
    return (
      <div className={styles.page}>
        {header ? <h1 className={styles.header}>{header}</h1> : null}
        {subheader ? <p className={styles.subheader}>{subheader}</p> : null}
        {text ? <div className={styles.text} dangerouslySetInnerHTML={{__html: text.replace(/\n/g,'<br/>')}} /> : null}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// banquet/components/Page/index.js